module.exports = __webpack_public_path__ + "img/information_inspiring_design_mob@2x.da53cac.webp";